module.exports = __webpack_public_path__ + "img/btn-border-black.9cc33f74.svg";